import templateUrl from "emun.auth/register-retailer-prompt.htm";
import open from "webmodals/open";
import controller from "emun.auth/register-retailer-prompt.controller";

export default options =>
  open({
    size: options.size || "lg",
    backdrop: "static",
    templateUrl: options.templateUrl || templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  }).result;
